<template>
	<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
		@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
		<template #default>
			<el-steps :space="70" direction="vertical" style="min-height: 200px;">
				<el-step v-for="(item,index) in flowsimulateContent" :key="index" :title="item.title"
					:description="item.description" :status="item.status">
				</el-step>
			</el-steps>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			flowsimulatedata: {
				default: () => {
					return []
				}
			},
			moduleName: {
				default: () => {
					return null
				}
			},

		},
		data() {
			return {
				modal_title: '流程模拟',
				modal_width: 600,
				modal_height: 800,
				flowsimulateContent: []
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.createflowsimulate()
			},
			createflowsimulate() {
				let flowsimulateContent = []
				this.flowsimulatedata.forEach((item) => {
					item.direction = item.direction == 1 ? '是' : '否'
					item.staffname = window.systemMethods.getstaff(item.staffid)
					item.staffname = Array.isArray(item.staffname) ? '' : item.staffname
					let obj = {
						title: '流程节点：',
						description: '',
						status: 'process',
					}
					if (item['nodetype'] == 998) {
						obj.title += '开始'
						obj.description = item.staffname?'发起人员' + ' 【 ' + item.staffname + '】':'发起'
					}
					if (item['nodetype'] == 1) {
						obj.title += item.tag
						obj.description = '操作人员' + ' 【 ' + item.staffname + '】'
					}
					if (item['nodetype'] == 3) {
						obj.title += '知会'
						obj.description = '知会人员' + ' 【' + item.staffname + '】'
					}
					if (item['nodetype'] == 2) {
						obj.title += '逻辑判断'
						obj.description = item.name + ' 【' + item.direction + '】'
					}
					if (item['nodetype'] == 999) {
						obj.title += '结束'
						obj.description = '完结'
					}
					if (item['nodetype'] == 997) {
						obj.title += '自动审核'
						obj.description = '自动审核'
					}
					if (item['nodetype'] == 996) {
						obj.title += '子流程'
						obj.description = item.name
					}
					flowsimulateContent.push(obj)
				})
				this.flowsimulateContent = flowsimulateContent


			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>